<template>
  <ItemPage
    title="Tipos de Tag"
    size="md"
    :actions="actions"
  >
    <template
      v-if="tagTypesView"
    >
      <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Pesquise pelo nome ou abreviatura"
        single-line
        hide-details
      /> -->
      <v-simple-table fixed-header>
        <template v-if="loading">
          <Load :loadingmsg="loadingMsg" />
        </template>
        <div
          v-else
          class="mr-5 ml-5"
        >
          <v-data-table
            :headers="headers"
            :items="contents"
            :items-per-page="15"
            :search="search"
            item-key="id"
            @click:row="editTagType($event)"
          />
        </div>
      </v-simple-table>
    </template>
    <template v-else>
      usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import NewTagDialog from '@/components/settings/NewTagDialog.vue'
import utils from '@/api/utils.js'
import ItemPage from '@/components/pages/ItemPage.vue'

export default {
  components: {
    Load,
    ItemPage
  },
  data () {
    return {
      tagTypesView: false,
      tagTypesCreate: false,
      loading: false,
      loadingMsg: '',
      renderComponent: 0,
      contents: [],
      search: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        }
      ]
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Adicionar Tipo de Tag',
          action: this.openNewTagDialog,
          icon: 'mdi-plus',
          disabled: !this.tagTypesCreate
        }
      ]
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.getTagTypes()
      this.tagTypesView = utils.checkPermissions('tag-types.view-any')
      this.tagTypesCreate = utils.checkPermissions('tag-types.create')
    },
    async getTagTypes () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        const content = await this.$api.getTagTypes()
        this.contents = content
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível listar tags, tente novamente mais tarde.', color: 'red' })
      }
      this.loading = false
    },
    editTagType (event) {
      this.$router.push({ name: 'tag-type.id', params: { id: event.id } })
    },
    openNewTagDialog () {
      this.$dialog.custom(NewTagDialog).with({ title: 'tipo de tag' }).show()
        .then((tag) => tag && this.newTagType(tag))
    },
    async newTagType (data) {
      this.loadingMsg = 'Salvando...'
      try {
        await this.$api.newTagType(data)
        this.$store.dispatch('setSnackBar', { text: 'Salvo com sucesso.' })
        this.fetchAll()
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível salvar, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
